var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { editable, editObservable } from '../../../utils/mobx/decorators/editable';
import { memoize } from '../../../utils/mobx/decorators/memoize';
import { UTCdate } from '../../../utils/serializr/schema/inner/UTCdate';
export class BundleStore {
    parent;
    lastSelect = new Date();
    constructor({ parent }) {
        editObservable(this);
        this.parent = parent;
    }
    get bundle() {
        return this.parent;
    }
    static get serializeInfo() {
        return {
            props: {
                lastSelect: UTCdate(),
            },
        };
    }
}
__decorate([
    editable()
], BundleStore.prototype, "lastSelect", void 0);
__decorate([
    memoize
], BundleStore, "serializeInfo", null);
